import { render, staticRenderFns } from "./FlipbookItem.vue?vue&type=template&id=17a50f5c&scoped=true&"
import script from "./FlipbookItem.vue?vue&type=script&lang=js&"
export * from "./FlipbookItem.vue?vue&type=script&lang=js&"
import style0 from "./FlipbookItem.vue?vue&type=style&index=0&id=17a50f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a50f5c",
  null
  
)

export default component.exports